import { ref } from "vue";

const ids: Record<string, number> = {};

export function useUniqueId(prefix: string) {
  if (!ids[prefix]) {
    ids[prefix] = 0;
  }

  ids[prefix] += 1;

  const id = ref<string>(`${prefix}${ids[prefix]}`);

  return { id };
}
